/**
 * @param {object} number
 * @param {object} min
 * @returns {boolean}
 */
export const isEqualObjects = (obj1, obj2) =>
  JSON.stringify(obj1) === JSON.stringify(obj2);

export const filterObject = (obj, predicate) =>
  Object.fromEntries(Object.entries(obj).filter(predicate));

export const filterObjectByKey = (obj, keys) =>
  filterObject(obj, ([key]) => keys.includes(key));
